import React, { useContext } from 'react'
import { StockContext } from '../../Context/StockContext'
import CardProps from '../CardProps/CardProps'
import Bear_market_logo from '../../../Assets/Bear-Market-logo - 2.jpg'
import Arrow_Down from '../../../Assets/DownwardArrow.png'
import 'bootstrap/dist/css/bootstrap.min.css';
import './LowerStockPrice.css'

const LowerStockPrice = () => {

  const {NegativePriceStocks} = useContext(StockContext)
  // console.log(NegativePriceStocks)
  return (
    <section className='LowerStockPrice-container'>
      {NegativePriceStocks === null || NegativePriceStocks === undefined ?
      (<div className="spinner-border text-danger" role="status"></div>) 
      
      : NegativePriceStocks.length === 0 ? (<div><p>No Stocks with lower percentage difference available</p></div>)
      
      :
      NegativePriceStocks.map((item, index) => {
        return (<CardProps key={index} index={index} 
          market_logo={Bear_market_logo} Stock_Name={item.company_name}
          price = {item.latest_date_price} Arrow={Arrow_Down} percentage_difference={item.stock_price_difference} 
          textColor='red' Date={item.Date} from_date={item.from_date} to_date={item.to_date}
          />)
      }) 
    }
    </section>
  )
}

export default LowerStockPrice